import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
// import { VehicleEntryContextmenuComponent } from '@app/core/components/contextmenus';
import { CreateEditVehicleStatusComponent } from '@app/core/windows'; 


@Component({
  selector: 'vehicles-status-crud',
  templateUrl: './vehicles-status-crud.component.html',
  providers: [ DatasourceService ]
})
export class VehiclesStatusCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(CreateEditVehicleStatusComponent, {static: false}) window !: CreateEditVehicleStatusComponent;

  protected menu: string = 'Conceptos';

  protected menuIcon: string = 'gears';

  protected label: string = 'Estatus de Vehículo';

  protected name: string = 'Estatus de Vehículos';

  protected table: string = 'vehicles_status';
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }
  
  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'name', dir: 'asc'}
    ];

    return s;

  }

  public onCustomExcelExport(e: any, allData: Array<any>): void {

    console.log('onCustomExcelExport');

    const rows = e.workbook.sheets[0].rows;

    let index = 0;
    rows.forEach((row) => {
      if (row.type === 'data') {+
        index++;
        row.cells.forEach((cell, i) => {
          if(typeof cell._column != 'undefined'){
            switch(cell._column){
              case 'Nombre': {
                cell.background = '#' + allData[index-1].color;
                cell.color = '#ffffff';
              }; break;
            }
          }
        });
      }
    });

  }

  ngOnInit() { 
    
    super.ngOnInit();    
  
  }

}